(function () {
  'use strict';

  if (window.__sicilusNavigationGuardInstalled) return;
  window.__sicilusNavigationGuardInstalled = true;

  var STORAGE_KEY = 'sicilus:last-menu-target';
  var MAX_AGE_MS = 8000;
  var CART_PATH = /(?:^|\/)cart\/?$/i;

  function clearTarget() {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (error) {}
  }

  function getTarget() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      clearTarget();
      return null;
    }
  }

  function saveTarget(url) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        target: url.pathname + url.search + url.hash,
        timestamp: Date.now()
      }));
    } catch (error) {}
  }

  function getInternalUrl(anchor) {
    var href = anchor && anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#' || /^javascript:/i.test(href)) return null;

    try {
      var url = new URL(href, window.location.href);
      if (url.origin !== window.location.origin) return null;
      return url;
    } catch (error) {
      return null;
    }
  }

  function isMenuLink(anchor) {
    return !!anchor.closest('.hdt-navigation, .hdt-header-menu-mobile, #hdt-nav-ul, #menu_mobile, [data-menu-drawer]');
  }

  function rememberMenuTarget(event) {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof event.button === 'number' && event.button > 0) return;

    var anchor = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!anchor) return;

    if (anchor.closest('.hdt-site-nav_cart')) {
      clearTarget();
      return;
    }

    if (!isMenuLink(anchor)) return;

    var url = getInternalUrl(anchor);
    if (!url || CART_PATH.test(url.pathname)) return;
    saveTarget(url);
  }

  function recoverWrongCartLanding() {
    var record = getTarget();
    if (!record) return;

    clearTarget();

    if (!CART_PATH.test(window.location.pathname || '')) return;
    if (!record.target || !record.timestamp || Date.now() - record.timestamp > MAX_AGE_MS) return;

    try {
      var targetUrl = new URL(record.target, window.location.origin);
      if (targetUrl.origin !== window.location.origin || CART_PATH.test(targetUrl.pathname)) return;
      window.location.replace(targetUrl.pathname + targetUrl.search + targetUrl.hash);
    } catch (error) {}
  }

  function containCartHitArea() {
    if (document.getElementById('sicilus-navigation-guard-css')) return;
    var style = document.createElement('style');
    style.id = 'sicilus-navigation-guard-css';
    style.textContent = '.hdt-site-nav_cart{flex:0 0 auto!important;width:auto!important;max-width:max-content!important;position:relative!important;isolation:isolate!important}.hdt-site-nav_cart>a{display:inline-flex!important;flex:0 0 auto!important;width:auto!important;max-width:max-content!important;position:relative!important;inset:auto!important;z-index:2!important}';
    document.head.appendChild(style);
  }

  recoverWrongCartLanding();
  containCartHitArea();
  document.addEventListener('pointerdown', rememberMenuTarget, true);
  document.addEventListener('click', rememberMenuTarget, true);
})();
